import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("6ftc0"), parcelRequire.load("9f8mp"), parcelRequire.load("eew9e"), parcelRequire.load("iHCTJ"), parcelRequire.load("eYc7M"), parcelRequire.load("k0Vga")]).then(() => {
let originalModule = parcelRequire("i9ilt");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("6ftc0")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9f8mp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("eew9e")} />
  <link rel="modulepreload" href={parcelRequire.resolve("iHCTJ")} />
  <link rel="modulepreload" href={parcelRequire.resolve("eYc7M")} />
  <link rel="modulepreload" href={parcelRequire.resolve("k0Vga")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
